import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import RolesChecker from 'features/customer/components/RolesChecker';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import MobilePhoneFormSection from 'features/requirements/sections/requirementFormTypes/mobilePhoneForm/MobilePhoneFormSection';

type Props = {}

const ChangeMobilePage = (props: Props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  const tLabels = useTranslation("customer\\customer").t;

  return (
    <RolesChecker enabledRoles="Contributor">
      <Header title={t("changeMobilePage.title")} 
        includeBreadcrumbs
        links={[
          { text: t("customer.title"), to: "/customer" }
        ]} 
      />
      <ModuleContent>
        <MobilePhoneFormSection 
          useOutsideOfRequirements  
          sendButtonTitle={tLabels("changeMobilePage.changeMobile")} 
        />
      </ModuleContent>
    </RolesChecker>
  )
}

export default ChangeMobilePage;